var EndPoints;
(function (EndPoints) {
    EndPoints["LOGIN"] = "/authenticate";
    EndPoints["CONFIRM_REGISTRATION"] = "/confirm-registration";
    EndPoints["ACCEPT_INVITE_REGISTER"] = "/accept-invite/register";
    EndPoints["ACCEPT_INVITE_LOGIN"] = "/accept-invite/login";
    EndPoints["REGISTER"] = "/register";
    EndPoints["FORGOT_PASSWORD"] = "/forgot-password";
    EndPoints["RESET_PASSWORD"] = "/reset-password";
    EndPoints["LOGOUT"] = "/logout";
    EndPoints["REFRESH_TOKEN"] = "/authenticate/refresh-token";
    EndPoints["REFRESH_TOKEN_ON_BEHALF_OF"] = "/refresh_token/:id";
    EndPoints["USER"] = "/user";
    EndPoints["USER_UNREGISTER"] = "/user/unregister";
    EndPoints["USER_ADD_ORGANISATION"] = "/user/add-organisation";
    EndPoints["ORGANISATION_USERS"] = "/organisation/:organisationId/users";
    EndPoints["ORGANISATION_USERS_ID"] = "/organisation/:organisationId/users/:userId";
    EndPoints["ORGANISATION_USERS_INVITE"] = "/organisation/:organisationId/users/invite";
    EndPoints["ORGANISATION_INVITES_ID"] = "/organisation/:organisationId/invites/:userId";
    EndPoints["ORGANISATION_USER_ROLE_UPDATE"] = "/organisation/:organisationId/users/role";
    EndPoints["ORGANISATION_FEED"] = "/organisationfeed/:organisationId/feed";
    EndPoints["ORGANISATION_FEED_ID"] = "/organisationfeed/:organisationId/feed/:feedId";
    EndPoints["ORGANISATION_FEEDS"] = "/organisationfeed/:organisationId/feeds";
    EndPoints["ORGANISATION_LABELS"] = "/labels/:organisationId";
    EndPoints["ORGANISATION_LABELS_ALL"] = "/labels/:organisationId/labels";
    EndPoints["ORGANISATION_LABEL"] = "/labels/:organisationId/:labelId";
    EndPoints["ORGANISATION_ASSETS"] = "/feeddata/latest/:organisationId";
    EndPoints["ORGANISATION_ASSETS_ARCHIVED"] = "/assets/:organisationId/archived-assets";
    EndPoints["ORGANISATION_ASSET"] = "/assets/:organisationId/asset/:assetId";
    EndPoints["ORGANISATION_ASSET_MANUAL_CREATE"] = "/assets/:organisationId/asset/create";
    EndPoints["ORGANISATION_ASSET_MANUAL_UPDATE"] = "/assets/:organisationId/asset/:serialNumber";
    EndPoints["ORGANISATION_ASSET_MANUAL_UPDATE_DATA"] = "/assets/:organisationId/asset/data/update";
    EndPoints["ORGANISATION_ASSET_MANUAL_ASSETS"] = "/assets/:organisationId/manual-assets";
    EndPoints["ORGANISATION_ASSET_UPDATE_ICON"] = "/assets/:organisationId/asset/:serialNumber/icon";
    EndPoints["ORGANISATION_ASSET_UPDATE_ALIAS"] = "/assets/:organisationKey/asset/:serialNumber/alias";
    EndPoints["ORGANISATION_ASSET_DELETE_ALIAS"] = "/assets/:organisationKey/asset/:serialNumber/alias/delete";
    EndPoints["ORGANISATION_ASSET_UPDATE_REMARK"] = "/assets/:organisationKey/asset/:serialNumber/remark";
    EndPoints["ORGANISATION_ASSET_DELETE_REMARK"] = "/assets/:organisationKey/asset/:serialNumber/remark/delete";
    EndPoints["ORGANISATION_ASSET_ARCHIVE"] = "/assets/:organisationId/asset/:assetId/archive";
    EndPoints["ORGANISATION_ASSET_UNARCHIVE"] = "/assets/:organisationId/asset/:assetId/unarchive";
    EndPoints["ORGANISATION_ASSET_LABELS"] = "/assets/:organisationId/asset/:assetId/labels";
    EndPoints["ORGANISATION_ASSET_LABELS_ADD"] = "/assets/:organisationId/asset/:assetId/labels/add/:labelId";
    EndPoints["ORGANISATION_ASSET_LABELS_DELETE"] = "/assets/:organisationId/asset/:assetId/labels/delete/:labelId";
    EndPoints["GET_ALL_ASSET_ICONS"] = "/assets/:organisationId/icon/all";
    EndPoints["SERVICE_SCHEMAS"] = "/service/:organisationId/schemas";
    EndPoints["SERVICE_SCHEMA"] = "/service/:organisationId/schemas/:schemaId";
    EndPoints["SERVICE_ASSET_SCHEMAS"] = "/service/:organisationId/schemas/asset/:assetId";
    EndPoints["SERVICE_ASSET_SCHEMA_ASSIGN"] = "/service/:organisationId/schemas/:schemaId/assignToAsset/:assetId";
    EndPoints["SERVICE_ASSET_SCHEMA_REMOVE"] = "/service/:organisationId/schemas/:schemaId/removeFromAsset/:assetId";
    EndPoints["SERVICE_ENTRIES"] = "/service/:organisationId/entries";
    // @deprecated
    EndPoints["SERVICE_ENTRIES_ASSET"] = "/service/:organisationId/entries/asset/:assetId";
    EndPoints["SERVICE_ENTRIES_ASSET_OPEN"] = "/service/:organisationId/entries/asset/:assetId/open";
    EndPoints["SERVICE_ENTRIES_ASSET_CLOSED"] = "/service/:organisationId/entries/asset/:assetId/closed";
    EndPoints["SERVICE_ENTRIES_OPEN"] = "/service/:organisationId/entries/open";
    EndPoints["SERVICE_ENTRIES_CLOSED"] = "/service/:organisationId/entries/closed";
    EndPoints["SERVICE_ENTRIES_CLOSED_PAGINATED"] = "/service/:organisationId/entries/closed-paginated?requestedPage=:requestedPage&numberOfItemsPerPage=:numberOfItemsPerPage";
    EndPoints["SERVICE_ENTRY_CLOSE"] = "/service/:organisationId/entries/:serviceEntryId/Close";
    EndPoints["SERVICE_ENTRY_TO_IN_PROGRESS"] = "/service/:organisationId/entries/:serviceEntryId/ToInProgress";
    EndPoints["SERVICE_ENTRY"] = "/service/:organisationId/entries/:serviceEntryId";
    EndPoints["SERVICE_ENTRY_CLOSE_RETROACTIVELY"] = "/service/:organisationId/entries/:serviceEntryId/CloseRetroactively";
    EndPoints["REPORTS_DEFINITIONS"] = "/:organisationId/reports";
    EndPoints["REPORTS_FILTER_VALUES"] = "/:organisationId/reports/:reportId/list-values/:parameterId";
    EndPoints["REPORTS_RUN"] = "/:organisationId/reports/:reportId/run";
    EndPoints["METRICS_ALL"] = "/Metrics/:organisationId/measurements/all";
    EndPoints["METRICS_AVAILABLE"] = "/Metrics/:organisationId/measurements";
    EndPoints["METRICS_SAMPLES_RAW"] = "/Metrics/:organisationId/rawsamples";
    EndPoints["METRICS_SAMPLES_AGGREGATE"] = "/Metrics/:organisationId/aggregate-samples";
    EndPoints["METRICS_LOCATION_SAMPLES_AGGREGATE"] = "/Metrics/:organisationId/location/aggregate-samples";
    EndPoints["LIST_ORGANISATION_DEVICES"] = "/devices/:organisationId";
    EndPoints["GET_DEVICE_MESSAGES"] = "/devices/:organisationId/:device/list-messages";
    EndPoints["GET_LATEST_DEVICE_STATUS"] = "/devices/:organisationId/:device/latest-data";
    EndPoints["ORGANISATION_DEVICE_SETTINGS"] = "/devices/:organisationId/:device/device-settings";
    EndPoints["UPDATE_DEVICE_OPERATING_HOURS"] = "/devices/:organisationId/:device/operating-hours?value=:value";
    EndPoints["DEVICE_UPDATE_NAME"] = "/devices/:organisationId/:device/name";
    EndPoints["DEVICE_DETACH"] = "/devices/:organisationId/detach";
    EndPoints["LOCATION_LOOKUP_BATCH"] = "/Location/reverse-lookup-batch";
    EndPoints["AZURE_MAPS_ADDRESS"] = "https://atlas.microsoft.com/search/address/json?subscription-key=X3Mkj4ssGG-pfMJjKC2VfSuyUOML3hO57O4b1isa6F0&api-version=1.0&query=:address";
    EndPoints["AZURE_MAPS_REVERSE_ADDRESS"] = "https://atlas.microsoft.com/search/address/reverse/json?subscription-key=X3Mkj4ssGG-pfMJjKC2VfSuyUOML3hO57O4b1isa6F0&api-version=1.0&query=:lat,:lng";
})(EndPoints || (EndPoints = {}));
export default EndPoints;
export function applyPathVariables(path, variables) {
    var keys = Object.keys(variables);
    keys.forEach(function (key) {
        path = path.replace(':' + key, variables[key]);
    });
    return path;
}
